import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import { getFeaturedMovies, getLatestMovies, movies } from '@/mocks/movies';

export default function Home() {
  const featuredMovies = getFeaturedMovies();
  const latestMovies = getLatestMovies(8);
  const popularTV = movies.filter((m) => m.category === 'dianshiju' || m.category === 'zongyi').slice(0, 4);

  useEffect(() => {
    document.title = '7777影院 | 77777影院免费电视剧与最新电影综艺 | 在线不缓冲高清全集';
  }, []);

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '7777影院',
    url: 'https://7777yingyuan.com',
    description: '7777影院汇集最新电影、免费电视剧和热门综艺节目，支持在线不缓冲播放，资源每日更新',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://7777yingyuan.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '7777影院',
    url: 'https://7777yingyuan.com',
    description: '7777影院汇集最新电影、免费电视剧和热门综艺节目，支持在线不缓冲播放',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>

      <main>
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Chinese%20cinema%20theater%20interior%20with%20warm%20red%20velvet%20seats%20golden%20decorative%20elements%20dramatic%20stage%20lighting%20elegant%20movie%20palace%20atmosphere%20rich%20dark%20warm%20colors%20professional%20architectural%20photography&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
            alt="7777影院 - 在线观看高清影视"
            title="7777影院 - 最新电影免费电视剧在线观看平台"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
              7777影院
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8">
              汇集最新电影、免费电视剧和热门综艺节目，支持在线不缓冲播放，资源每日更新，让你第一时间追剧看电影
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <Link
                to="/category/dongzuo"
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </Link>
              <Link
                to="/category/dianshiju"
                className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white border border-white/30 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2 backdrop-blur-sm"
              >
                <i className="ri-tv-line text-lg"></i>
                热门电视剧
              </Link>
            </div>
            <div className="flex items-center gap-6 mt-10">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">{movies.length}+</p>
                <p className="text-xs text-white/60 mt-1">精选影视</p>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">12</p>
                <p className="text-xs text-white/60 mt-1">分类频道</p>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日</p>
                <p className="text-xs text-white/60 mt-1">资源更新</p>
              </div>
            </div>
          </div>
        </section>

        <CategoryTabs />

        <section className="py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <span className="w-1 h-5 rounded-full bg-primary-500"></span>
                <h2 className="text-lg font-heading font-bold text-foreground-900">推荐精选</h2>
              </div>
              <Link
                to="/category/kehuan"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer"
              >
                查看更多 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {featuredMovies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} variant="default" />
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <span className="w-1 h-5 rounded-full bg-accent-500"></span>
                <h2 className="text-lg font-heading font-bold text-foreground-900">最新更新</h2>
              </div>
              <Link
                to="/category/dongzuo"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {latestMovies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} variant="default" />
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <span className="w-1 h-5 rounded-full bg-secondary-500"></span>
                <h2 className="text-lg font-heading font-bold text-foreground-900">热播剧集 &amp; 综艺</h2>
              </div>
              <Link
                to="/category/dianshiju"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer"
              >
                更多剧集 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {popularTV.map((movie) => (
                <MovieCard key={movie.id} movie={movie} variant="default" />
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 mb-8 justify-center">
              <span className="w-1 h-5 rounded-full bg-primary-500"></span>
              <h2 className="text-lg font-heading font-bold text-foreground-900">为什么选择7777影院</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-flashlight-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">极速不缓冲</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  采用先进CDN加速技术，全国多节点部署，确保在线观看流畅不卡顿
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-hd-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">超高清画质</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  支持1080P/4K超高清画质播放，给你影院级的视听享受体验
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-refresh-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">每日更新</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  资源每日更新，最新上映电影和热门剧集第一时间同步上线
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-shield-check-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">完全免费</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  所有影视资源完全免费在线观看，无需注册会员，无需付费订阅
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              追剧看电影，就来7777影院
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto mb-8">
              7777影院每日更新海量影视资源，最新电影、热门电视剧、精彩综艺随时看，高清不缓冲，追剧更畅快
            </p>
            <Link
              to="/category/kehuan"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              立即开始观影体验
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}